import { render, staticRenderFns } from "./endurance.vue?vue&type=template&id=a0f4e058&scoped=true&"
import script from "./endurance.vue?vue&type=script&lang=js&"
export * from "./endurance.vue?vue&type=script&lang=js&"
import style0 from "./endurance.vue?vue&type=style&index=0&id=a0f4e058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f4e058",
  null
  
)

export default component.exports